import { ReactNode, StrictMode } from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { de } from "date-fns/locale/de";
import { BrowserRouter } from "react-router-dom";
import { SessionProvider } from "./authentication/SessionProvider";
import { AppFwContext } from "./AppFwContext.ts";
import { AppFwContextContextProvider } from "./AppFwContextContextProvider.tsx";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { NotificationsProvider } from "./notifications/notifications-provider";
import ServiceWorkerUpdateDialog from "./ui/service-worker-update-dialog.tsx";


// TODO: log errors?
// bind error logging at first
// window.onerror = (e: any) => {
//     logError(e, 'console.eventer.app/index.tsx')
// }
// window.onunhandledrejection = (e: any) => {
//     logError(e, 'console.eventer.app/index.tsx')
// }

interface AppFwWrapperProps {
    readonly appFwContext: AppFwContext;
    readonly children?: ReactNode;
}

export default function AppFwWrapper(props: AppFwWrapperProps) {
    return (
        <>
            <StrictMode>
                <CssBaseline />
                <GlobalStyles styles={{
                    'html, body, #root': {
                        overscrollBehavior: 'none'
                    }
                }} />
                <AppFwContextContextProvider appFwContext={props.appFwContext}>
                    <QueryClientProvider client={props.appFwContext.queryClient}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
                            <BrowserRouter>
                                <SessionProvider>
                                    <NotificationsProvider>
                                        {props.children}
                                        <ServiceWorkerUpdateDialog />
                                    </NotificationsProvider>
                                </SessionProvider>
                            </BrowserRouter>
                        </LocalizationProvider>
                    </QueryClientProvider>
                </AppFwContextContextProvider>
            </StrictMode>
        </>
    )
}
